import React from 'react';

const ProgressStepper = ({ currentStep, totalSteps }) => {
  // Basic implementation for now, will be styled later
  return (
    <div className="flex justify-between items-center mb-8">
      {[...Array(totalSteps)].map((_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;

        let stepClasses = 'w-8 h-8 rounded-full flex items-center justify-center ';
        if (isActive) {
          stepClasses += 'bg-brand-accent-orange text-white';
        } else if (isCompleted) {
          stepClasses += 'bg-brand-green text-white';
        } else {
          stepClasses += 'bg-gray-300 text-gray-600';
        }

        let lineClasses = 'flex-1 h-1 ';
        if(isCompleted) {
            lineClasses += 'bg-brand-green';
        } else {
            lineClasses += 'bg-gray-300';
        }

        return (
          <React.Fragment key={stepNumber}>
            <div className={stepClasses}>{stepNumber}</div>
            {stepNumber < totalSteps && <div className={lineClasses}></div>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressStepper; 